<template>
    <div class="all">
        <van-nav-bar
                :title="title"
                left-text="返回"
                right-text
                left-arrow
                @click-left="$goBack()"
                @click-right
        />
        <div class="showContent">
            <van-row>
                <van-col span="2">
                    <img :src="person">
                </van-col>
                <van-col span="10">
                    <van-field v-model="from.phone" placeholder="请输入手机号"/>
                </van-col>
            </van-row>

            <van-row>
                <van-col span="2">
                    <img :src="yanzhengma">
                </van-col>
                <van-col span="14">
                    <van-field v-model="from.code" placeholder="请输入验证码"/>
                </van-col>
                <van-col span="8">
                    <van-button size="small" @click='sendCode()'
                                :disabled="timerCodeBtn.time > 0"
                                :plain="timerCodeBtn.time > 0"
                    >
                        {{timerText}}
                    </van-button>

                </van-col>
            </van-row>
            <van-row>
                <van-col span="2">
                    <img :src="suo">
                </van-col>
                <van-col span="14">
                    <van-field
                            v-model="from.pwd"
                            placeholder="请输入新密码"
                    />
                </van-col>

            </van-row>

            <van-row>
                <van-col span="2">
                    <img :src="suo">
                </van-col>
                <van-col span="14">
                    <van-field
                            v-model="from.pwdVerify"
                            placeholder="再次输入新密码"
                    />
                </van-col>
            </van-row>
        </div>

        <div class="bottom">
            <van-button type="default" size="large" @click="newPassWord()" :loading="submitLoading" loading-text="提交中...">确 认 提 交
            </van-button>
        </div>


    </div>


</template>

<script>
    import yanzhengma from '@/assets/images/yanzhengma1.png'
    import person from '@/assets/images/person1.png'
    import suo from '@/assets/images/suo.png'
    import userAPI from '@/api/user'

    export default {
        data() {
            return {
                person: person,
                yanzhengma: yanzhengma,
                suo: suo,
                submitLoading: false,
                title:'找回密码',
                from: {
                    phone: '',
                    pwd: '',//新密码
                    pwdVerify: '',//确认密码
                    code: ''//手机验证码
                },
                timerCodeBtn: {
                    time: 0,
                    disabled: false
                },
                newPassList: []
            }
        },
        computed: {
            timerText: function () {
                return this.timerCodeBtn.time > 0 ? this.timerCodeBtn.time + 'S再获取' : '发送验证码';
            }
        },
        created() {
            if(this.$route.meta){
               this.title =   this.$route.meta.title
            }
        },
        methods: {
            //新密码
            newPassWord() {
                this.submitLoading = true
                userAPI.newPass(this.from).then((result) => {
                    this.$toast.success('修改成功')
                    this.submitLoading = false
                    this.$router.push("/login")
                }).catch(()=>{
                  this.submitLoading = false
                })
            },
            timer: function () {
                if (this.timerCodeBtn.time > 0) {
                    this.timerCodeBtn.time--
                    setTimeout(this.timer, 1000)
                }
            },
            sendCode() {
                if (!this.$myUtil.mobile(this.from.phone)) {
                    this.$toast("手机号不正确")
                    return
                }
                this.$http({
                    url: '/code/send',
                    method: 'get',
                    params: {phone: this.from.phone}
                }).then((result) => {
                    this.timerCodeBtn.time = 90
                    this.timer()
                }).catch((error) => {
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .all {
        background-color: #fff;
    }

    .showContent {
        margin-top: 1rem;
        font-size: 1.1rem;
        .van-row {
            margin: 0.5rem 1rem 0rem 3rem;
            line-height: 3.5rem;
            img {
                height: 1.5rem;
                width: 2rem;
            }
            border-style: none;
            border-bottom-style: solid;
            border-bottom-width: thin;
            border-bottom-color: #f2f2f2;
            .van-button {
                border-radius: 1rem;
                background-color: #ee9900;
                color: #fff;
            }
        }

    }

    .bottom {
        margin: 3rem 15% 0rem 15%;
        .van-button {
            border-radius:3rem;
            background-color: #ee9900;
            color: #fff;
        }
    }

</style>
